import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrent, getToken } from '../../actions/webLessons'
import { useParams } from 'react-router-dom'
import Loader from '../../components/Loader'
import Button from '../../components/Button'
import { ConnectModal, MainBlock, NavPanel, StudentsBlock, FilesBlock, ModesBlock, DialogModal } from './Components'
import styles from './styles.module.scss'
import { useLivekitRoom } from '../../hooks/useLivekitRoom'
import { LIVEKIT_URL } from '../../assets/const'
import { WebLessonsContext } from '../../utils/context'


const metadataPlug = { organization: 'organization', position: 'teacher', topic: '', username: '' }

const Current = () => {
  
  const livekitData = useLivekitRoom({ serverUrl: LIVEKIT_URL })
  const {room, joinRoom} = livekitData


  const dispatch = useDispatch()
  const { id } = useParams()
  const { current: data, loading } = useSelector(state => state.web_lessons)
  const { displayname } = useSelector(state => state.auth)

  useEffect(() => {
    dispatch(getCurrent(id))
  }, [])
  
  const connectStreamHandler = async (mediaParams) => {
    try {
      const payload = {
        roomName: data.stream,
        participantName: displayname,
        metadata: {...metadataPlug, username: displayname},
      }
      const token = await dispatch(getToken(id, payload));
      await joinRoom(token, mediaParams);
    } catch (err) {
      console.error("Ошибка при подключении:", err);
    }

  }

  if (loading) return <Loader/>;

  return (
    <WebLessonsContext.Provider value={livekitData}>
      <div className={styles.wrapper}>
        {!room
          ? <div>
              <h1>Открытый урок</h1>
              <p><b>Тема:</b>{data?.stream}</p>
              <p><b>Описание:</b>{data?.description}</p>
            </div>
          : (
            <>
              <section>
                <NavPanel data={data}/>
                <ModesBlock/>
                <FilesBlock/>
                <MainBlock/>          
                <StudentsBlock/>
              </section>
              <DialogModal/>
            </>
          )
        }
        <ConnectModal
          streamActive={!!room}
          connectStream={connectStreamHandler}
        />
      </div>
    </WebLessonsContext.Provider>
  )
}

export default Current